import React, { useState } from 'react';

const GradientButton = ({ size, children, onClick, variant, disabled = false, type = 'button' }) => {
	const [hover, setHover] = useState(false);
	const getGradientStyle = (variant) => {
		switch (variant) {
			case 'light-blue':
				return {
					background: hover ? 'white' : 'linear-gradient(270deg, #028AFD 0.05%, #015297 99.95%)',

					color: hover ? 'black' : 'white',
					boxShadow: hover
						? ' 0px 6px 20px 0px rgba(137, 137, 137, 0.39)'
						: '0px 6px 20px 0px rgba(134, 194, 255, 0.59)',
				};
			case 'royal-blue':
				return {
					background: hover ? 'white' : 'linear-gradient(90deg, #2F6EFF 0%, #171B8E 100%)',
					color: hover ? 'black' : 'white',
					boxShadow: hover
						? ' 0px 6px 20px 0px rgba(137, 137, 137, 0.39)'
						: '0px 6px 20px 0px rgba(134, 194, 255, 0.59)',
					dropShadow: hover ? ' 0px 6px 20px 0px rgba(137, 137, 137, 0.39)' : 'none',
				};
			default:
				return {
					background: 'white',
					color: 'black',
					boxShadow: hover
						? '0px 6px 10px 0px rgba(137, 137, 137, 0.39)'
						: '0px 6px 20px 0px rgba(137, 137, 137, 0.39)',
				};
		}
	};

	return (
		<button
			className={`disabled:cursor-not-allowed outline-pd-blue outline-2 outline -outline-offset-1 rounded-full  cursor-pointer font-bold flex justify-center gap-8 items-center content-center ${
				size === 'small' ? ' px-36 md:px-40 py-8' : 'px-16 sm:px-20 sm:py-8 py-8 md:py-12 md:px-20'
			}`}
			disabled={disabled}
			onClick={onClick}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			style={getGradientStyle(variant)}
			// eslint-disable-next-line react/button-has-type
			type={type}
		>
			{children}
		</button>
	);
};
export default GradientButton;
